export const generateCertificateHtml = ({ 
    certificateNumber, certificateIssueDate, vehicleNumber, 
    co2Emission, userName, baseUsername,
    dpiitLogo, startupLogo, pureLogo, signImage 
}) => `
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Green Certificate - CO2 Emission</title>
    <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,600;1,400&family=Rajdhani:wght@500;600;700&display=swap" rel="stylesheet">
    <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }

        body {
            font-family: 'EB Garamond', serif;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            background-color: #e8ecf0;
        }

        .certificate-outer {
            border: 8px solid #1a3a8c;
            padding: 6px;
            width: 720px;
            background: #1a3a8c;
        }

        .certificate-inner {
            border: 3px solid #1a3a8c;
            background-color: #ffffff;
            padding: 32px 36px 28px;
            position: relative;
        }

        /* Thin inner accent line */
        .certificate-inner::before {
            content: '';
            position: absolute;
            inset: 6px;
            border: 1px solid #c8d4f0;
            pointer-events: none;
        }

        /* Header row */
        .header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 6px;
        }

        .cert-number {
            font-family: 'Rajdhani', sans-serif;
            font-size: 12px;
            font-weight: 600;
            color: #333;
            line-height: 1.5;
        }
        .cert-number span {
            display: block;
            color: #1a3a8c;
            font-size: 13px;
        }

        .collaboration {
            text-align: center;
            flex: 1;
            margin: 0 20px;
        }
        .collaboration p {
            font-size: 10px;
            color: #555;
            margin-bottom: 4px;
            font-style: italic;
            text-decoration: underline;
        }
        .collaboration img {
            height: 52px;
            object-fit: contain;
        }
        .collaboration .govt-text {
            font-size: 9.5px;
            color: #333;
            line-height: 1.5;
            margin-top: 4px;
            text-decoration: none;
            font-style: normal;
        }

        .right-logos {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 6px;
        }
        .right-logos img.pure-logo {
            height: 60px;
            width: 60px;
            object-fit: contain;
        }
        .startup-tag {
            font-family: 'Rajdhani', sans-serif;
            font-size: 13px;
            font-weight: 700;
            color: #333;
        }
        .startup-tag span { color: #e07000; }
        .startup-tag .plus { color: #1a9c3e; font-size: 16px; line-height: 1; }

        /* Divider */
        .divider {
            border: none;
            border-top: 1.5px solid #1a3a8c;
            margin: 14px 0 18px;
        }

        /* Title block */
        .title-block {
            text-align: center;
            margin-bottom: 18px;
        }
        .title-block h1 {
            font-family: 'Rajdhani', sans-serif;
            font-size: 30px;
            font-weight: 700;
            color: #1a3a8c;
            letter-spacing: 2px;
            text-transform: uppercase;
            margin-bottom: 4px;
        }
        .title-block h2 {
            font-family: 'EB Garamond', serif;
            font-size: 16px;
            font-weight: 400;
            color: #333;
            letter-spacing: 0.5px;
        }

        /* Body text */
        .cert-body {
            text-align: center;
            font-size: 16px;
            color: #222;
            line-height: 2;
            margin-bottom: 10px;
        }
        .cert-body .highlight {
            color: #1a3a8c;
            font-weight: 600;
        }

        /* Plant recommendation */
        .recommendation {
            text-align: center;
            font-size: 15px;
            color: #222;
            line-height: 1.8;
            margin: 8px 0 180px;
        }
        .recommendation .number {
            font-weight: 700;
            color: #1a3a8c;
            font-size: 16px;
        }

        /* Footer row */
        .footer-dates {
            display: flex;
            justify-content: center;
            gap: 80px;
            margin-top: 30px;
            margin-bottom: 20px;
        }
        .footer-dates .date-block {
            text-align: center;
        }
        .footer-dates .date-value {
            font-family: 'Rajdhani', sans-serif;
            font-size: 16px;
            font-weight: 700;
            color: #1a3a8c;
            border-bottom: 1.5px solid #555;
            padding-bottom: 3px;
            margin-bottom: 3px;
        }
        .footer-dates .date-label {
            font-size: 10px;
            letter-spacing: 1.5px;
            color: #555;
            text-transform: uppercase;
            font-family: 'Rajdhani', sans-serif;
            font-weight: 600;
        }

        /* Signature row */
        .signature-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 10px;
        }
        .sig-left {
            text-align: left;
        }
        .sig-left img {
            height: 50px;
            width: 140px;
            object-fit: contain;
            display: block;
            margin-bottom: 2px;
        }
        .sig-left p {
            font-size: 11px;
            color: #333;
        }

        .sig-right {
            text-align: right;
            font-size: 11px;
            color: #333;
            line-height: 1.7;
        }
        .sig-right .issuer {
            font-family: 'Rajdhani', sans-serif;
            font-weight: 700;
            color: #1a3a8c;
            font-size: 12px;
        }
        .sig-right .time {
            color: #1a3a8c;
        }

        /* Fine print */
        .fine-print {
            margin-top: 14px;
            font-size: 8px;
            color: #888;
            line-height: 1.6;
        }
    </style>
</head>
<body>
    <div class="certificate-outer">
        <div class="certificate-inner">

            <!-- Header -->
            <div class="header">
                <div class="cert-number">
                    CERTIFICATE NO:<br>
                    <span>${certificateNumber}</span>
                </div>

                <div class="collaboration">
                    <p>In Collaboration With :-</p>
                    <img 
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Emblem_of_India.svg/120px-Emblem_of_India.svg.png"
                        alt="Government of India Emblem"
                    >
                    <p class="govt-text">
                        Government of India<br>
                        Ministry of Commerce and Industry<br>
                        Department for Promotion of Industry and Internal Trade
                    </p>
                </div>

                <div class="right-logos">
                    <img src="${pureLogo}" alt="Pure Prakriti Logo" class="pure-logo">
                    <div class="startup-tag">#startup<span>india</span><span class="plus">+</span></div>
                </div>
            </div>

            <hr class="divider">

            <!-- Title -->
            <div class="title-block">
                <h1>Green Certificate</h1>
                <h2>CO&#8322; Emission Certification</h2>
            </div>

            <!-- Certificate Body -->
            <div class="cert-body">
                This is to certify that <span class="highlight">${userName && userName.length > 0 ? userName : baseUsername}</span>,
                bearing vehicle number <span class="highlight">${vehicleNumber}</span>, has<br>
                generated a total carbon emission of <span class="highlight">${(co2Emission).toFixed(1)}</span> unit CO&#8322;.
            </div>

            <div class="recommendation">
                To neutralize this environmental impact, it is recommended to plant
                <span class="number">1 🌱</span> towards<br>
                a greener and more sustainable future.
            </div>

            <!-- Dates -->
            <div class="footer-dates">
                <div class="date-block">
                    <div class="date-value">${certificateIssueDate}</div>
                    <div class="date-label">Date of Issue</div>
                </div>
                <div class="date-block">
                    <div class="date-value">${(function() {
                        const parts = certificateIssueDate.split('-');
                        if (parts.length === 3) {
                            return parts[0] + '-' + parts[1] + '-' + (parseInt(parts[2]) + 5);
                        }
                        return certificateIssueDate;
                    })()}</div>
                    <div class="date-label">Valid Upto</div>
                </div>
            </div>

            <!-- Signature -->
            <div class="signature-row">
                <div class="sig-left">
                    <img src="${signImage}" alt="Authorized Signature">
                    <p>Authorized Signature</p>
                </div>
                <div class="sig-right">
                    Issued by:<br>
                    <span class="issuer">Transvue Solution India Pvt. Ltd.</span><br>
                    <span class="time">Time: ${new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span>
                </div>
            </div>

            <!-- Fine print -->
            <div class="fine-print">
                * The above result is based on user input.<br>
                * Additional details are based on US/UK research.
            </div>

        </div>
    </div>
</body>
</html>
`;